<template>
    <BaseForm @submit.prevent>
        <template #fields>
            <FieldGroup :title="$t('identifiers')">
                <TextField
                    :value="values.nameShort"
                    :label="$t('name-short')"
                    :error-messages="errors.nameShort"
                    :required="true"
                    @input="setFieldValue('nameShort', ($event.target as HTMLInputElement).value)"
                    @blur="setFieldTouched('nameShort', true)"
                />
                <TextField
                    :value="values.nameLong"
                    :label="$t('name-long')"
                    :error-messages="errors.nameLong"
                    :required="true"
                    @input="setFieldValue('nameLong', ($event.target as HTMLInputElement).value)"
                    @blur="setFieldTouched('nameLong', true)"
                />
            </FieldGroup>
        </template>
        <template #buttons>
            <Button v-if="isTouched" size="Base" variant="Danger-Light" @click="onDiscard">
                <template #icon>
                    <UndoIcon class="size-5" />
                </template>
                {{ $t('discard') }}
            </Button>
            <Button v-else size="Base" variant="Neutral-Light" @click="$router.back">
                <template #icon>
                    <UndoIcon class="size-5" />
                </template>
                {{ $t('abort') }}
            </Button>
            <Button
                size="Base"
                variant="Info-Strong"
                :disabled-explanation="saveButtonDisabledExplanation"
                type="submit"
                @click="onSave"
            >
                <template #icon>
                    <AllDoneIcon class="size-5" />
                </template>
                {{ $t('create') }}
            </Button>
        </template>
    </BaseForm>
</template>
<script setup lang="ts">
import Button from '@/components/Button/Button.vue';
import BaseForm from '@/components/Form/BaseForm.vue';
import FieldGroup from '@/components/Form/FieldGroup.vue';
import TextField from '@/components/Form/TextField.vue';
import AllDoneIcon from '@/components/Icon/AllDoneIcon.vue';
import UndoIcon from '@/components/Icon/UndoIcon.vue';
import { useForm } from '@/forms/composables/useForm';
import { computed } from 'vue';
import { useScenarioGroupCreate } from '../composables/useScenarioGroupCreate';
import { gotToScenarioGroup } from '../scenario';
import { ScenarioGroupCreateSchema } from './schemas';

const {
    values,
    errors,
    isTouched,
    setFieldValue,
    setFieldTouched,
    validate,
    saveButtonDisabledExplanation,
    onDiscard,
} = useForm(
    ScenarioGroupCreateSchema,
    computed(() => ({
        nameShort: '',
        nameLong: '',
    })),
);

const { create } = useScenarioGroupCreate(values);

async function onSave() {
    const result = await validate();
    if (result) {
        const { id } = await create();
        if (id) {
            gotToScenarioGroup(id);
        }
    }
}
</script>
